import { createContext, useContext } from "react";
import { useFormContext } from "react-hook-form";

import type { AutoFormFieldProps } from "@autoform/react";

import { AreaPicker } from "@/components/fields/area-picker";

/** The city whose areas the venue enrichment's `area` is picked from: the venue's `geodata` name and country code. */
export interface AreaScope {
  city?: string;
  countryCode?: string;
  /** The page is saving. */
  disabled?: boolean;
}

export const AreaScopeContext = createContext<AreaScope>({});

/**
 * The venue enrichment's `area`, picked from the venue's city's official areas. The enrichment write takes the area as
 * text and the server resolves it (only an official name or alias changes the venue's area), so this stores the picked
 * area's official name, not its id.
 */
export function AreaEnrichmentField({ id }: AutoFormFieldProps) {
  const form = useFormContext();
  const scope = useContext(AreaScopeContext);
  const value = form.watch(id) as string | null | undefined;

  return (
    <AreaPicker
      city={scope.city}
      countryCode={scope.countryCode}
      valueBy="name"
      disabled={scope.disabled}
      value={value}
      onChange={(next) => form.setValue(id, next, { shouldDirty: true })}
    />
  );
}
